import { alertTypes } from './_actionTypes';

const success = (message) => async dispatch => {
    dispatch({ type: alertTypes.SUCCESS, payload: message });
}

const error = (message) => async dispatch => {
    dispatch({ type: alertTypes.ERROR, payload: message });
}

const clear = (message) => async dispatch => {
    dispatch({ type: alertTypes.CLEAR});
}

export const alertActions = {
    success, error, clear
}


// WEBPACK FOOTER //
// ./src/actions/alert.actions.js